// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"

const application = Application.start()

const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

Object.entries(controllers).forEach(([path, module]) => {
  const identifier = path
    .replace("./", "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")

  application.register(identifier, module.default)
})
